<template>
  <hover-down class="word-down-btn" style="display:inline-block;">
    <div slot="hoverBtn" class="more-btn">
      <div>
        <span v-text="content"></span>
        <img src="@/assets/img/icon/u414.png" />
      </div>
    </div>
    <div slot="down">
      <slot name="down"></slot>
    </div>
  </hover-down>
</template>

<script>
import HoverDown from '_c/dropdown/hoverDown'
export default {
  name: 'wordDown',
  components: {
    HoverDown,
  },
  props: {
    content: {
      type: String,
      default: '更多',
    },
  },
}
</script>

<style lang="scss" scoped>
.more-btn {
  vertical-align: top;
  position: relative;
  cursor: pointer;
  > div {
    > span {
      color: #0066cc;
    }
  }
  img {
    position: relative;
    // top: -21px;
    left: 3px;
  }
}
</style>
<style lang="scss">
.word-down-btn {
  .dropdown {
    top: 30px !important;
  }
}
</style>
